import { FormattedAxnAdminUserInvitation } from "@idw-types/data/axn-admin-user-invitation";

export enum OrganizationInvitationDetailsActionTypes {
    // Organization Invitation Details
    SET_ORGANIZATION_INVITATION_DETAILS_LOADING = "SET_ORGANIZATION_INVITATION_DETAILS_LOADING",
    SET_ORGANIZATION_INVITATION_DETAILS = "SET_ORGANIZATION_INVITATION_DETAILS"
}

//Organization Invitation Details
type SetOrganizationInvitationDetailsLoadingAction = {
    type: OrganizationInvitationDetailsActionTypes.SET_ORGANIZATION_INVITATION_DETAILS_LOADING,
    payload: { isLoading: boolean; }
};

export const setOrganizationInvitationDetailsLoading = (isLoading: boolean): SetOrganizationInvitationDetailsLoadingAction => ({
    type: OrganizationInvitationDetailsActionTypes.SET_ORGANIZATION_INVITATION_DETAILS_LOADING,
    payload: { isLoading }
});

type SetOrganizationInvitationDetailsAction = {
    type: OrganizationInvitationDetailsActionTypes.SET_ORGANIZATION_INVITATION_DETAILS,
    payload: { axnAdminUserInvitation: FormattedAxnAdminUserInvitation; }
}

export const setOrganizationInvitationDetails = (axnAdminUserInvitation: FormattedAxnAdminUserInvitation): SetOrganizationInvitationDetailsAction => ({
    type: OrganizationInvitationDetailsActionTypes.SET_ORGANIZATION_INVITATION_DETAILS,
    payload: { axnAdminUserInvitation }
});

export type OrganizationInvitationDetailsActions =
    // Organization Details Invitation 
    SetOrganizationInvitationDetailsLoadingAction |
    SetOrganizationInvitationDetailsAction